import { apiRequest } from '@/plugins/api.js';

export const apiRetrieveDefaultLanguage = () => apiRequest({
  url: 'api/getDefaultLanguage',
  method: 'GET',
}).then((response) => {
  const responseData = response?.data;

  if (!responseData) {
    return Promise.reject({ responseEnum: 'EMPTY_DATA' });
  }

  return { parsedData: responseData };
});

export const apiRetrieveLanguages = () => apiRequest({
  url: 'api/getAvailableLocales',
  method: 'GET',
}).then((response) => {
  const responseData = response?.data;
  const languageKeyList = responseData ? Object.keys(responseData) : [];

  if (!responseData || (languageKeyList.length === 0)) {
    return Promise.reject({ responseEnum: 'EMPTY_DATA' });
  }

  return {
    parsedData: responseData,
    languageKeyList,
  };
});

export const apiRetrieveTranslations = ({ lang }) => apiRequest({
  url: 'api/getTranslations',
  method: 'GET',
  params: { lang },
}).then((response) => {
  const responseData = response?.data;

  if (!Array.isArray(responseData) || (responseData.length === 0)) {
    return Promise.reject({ responseEnum: 'EMPTY_DATA' });
  }

  return {
    parsedData: responseData.reduce((o, [key, value]) => Object.assign(o, { [key]: value }), {}),
  };
});
